export default "__VITE_ASSET__2734b51f__"